<template>
  <div>
    <button
        v-if="!canHide || (canHide && isInCart)"
        :class="!isInCart ? disableClass : enableClass"
        type="submit"
        :disabled="!isInCart"
        @click="clickedRemove">
        <i class="bi bi-cart-dash-fill"></i>
    </button>
  </div>
</template>

<script lang="ts">
import { Options, Vue, prop } from "vue-class-component";

import { useCartStore } from "@/stores/cart";
import { usePhotoStore } from "@/stores/photo";

// Define props in a class
class ButtonRemoveFromCartProps {
  item = prop({
    // Same as Vue core's prop option
    type: Object,
    required: true,
    default: {}
  })
  canHide = prop({
    // Same as Vue core's prop option
    type: Boolean,
    required: false,
    default: false
  })
}

@Options({
  components: {
  }
})
export default class ButtonRemoveFromCart extends Vue.with(ButtonRemoveFromCartProps) {
  cartStore = useCartStore()
  photoStore = usePhotoStore()

  enableClass = "text-white btn btn-danger rounded-circle opacity-100"
  disableClass = "text-white btn btn-danger rounded-circle opacity-25"

  get isInCart() {
    return this.cartStore.isInCart(this.item.id)
  }

  public clickedRemove() {
    this.cartStore.deleteFromCart(this.item.id)
  }
}
</script>

<style lang="stylus">
</style>
